/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { ingestionStatusControllerGetDocumentStats } from "./ingestionStatusControllerGetDocumentStats";
import { ingestionStatusControllerGetFailures } from "./ingestionStatusControllerGetFailures";
import { ingestionStatusControllerGetFileStats } from "./ingestionStatusControllerGetFileStats";
import { ingestionStatusControllerGetFileWebAppLink } from "./ingestionStatusControllerGetFileWebAppLink";
import { ingestionStatusControllerGetJobStats } from "./ingestionStatusControllerGetJobStats";
import { ingestionStatusControllerGetPerformanceByPageCount } from "./ingestionStatusControllerGetPerformanceByPageCount";
import { ingestionStatusControllerGetPipelineHealth } from "./ingestionStatusControllerGetPipelineHealth";

export function documentIngestionStatusService() {
  return { ingestionStatusControllerGetFileStats, ingestionStatusControllerGetDocumentStats, ingestionStatusControllerGetJobStats, ingestionStatusControllerGetPipelineHealth, ingestionStatusControllerGetFailures, ingestionStatusControllerGetPerformanceByPageCount, ingestionStatusControllerGetFileWebAppLink }
}